var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vcp-controls"},[_c('div',{staticClass:"playback-control"},[_c('time-span')],1),_c('div',{staticClass:"setting-control"},[_c('picture-in-picture'),_c('settings-control'),_c('fullscreen-control')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }